<app-manage-template   [title]="'Manage Workspaces'"
(updateParent)="updateTeam($event)" (updateMembers)="updateTeamMembers($event)"
[KEY]="'MANAGE_WORKSPACES'" [COLUMNFIELDS]="columns" [dropdownContext]="filterData"
[parentData]="teamDetails"  [userData]="(teams | async)"
[onSearch]="onSearch" [onFilter]="onFilter" [this]="this"  [ownerView]="true"
[onScroll]="onScroll" [holder]="'Search by workspace name, user or email'">

<div class="row mt-1">
  <app-plan-card [cards]="allocationCards" [TOTAL]="PLANMAX"></app-plan-card>

</div>


</app-manage-template>
